{
  "version": 1,
  "asset_id": "1ae161f4-a33a-4301-812e-69d91cf2a6a5",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/1ae161f4-a33a-4301-812e-69d91cf2a6a5/esenyurt-hizli-elektrikci-7-24-dukkan-3.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/1ae161f4-a33a-4301-812e-69d91cf2a6a5/esenyurt-hizli-elektrikci-7-24-dukkan-3.jpg",
  "original_filename": "esenyurt-hizli-elektrikci-7-24-dukkan-3.jpg",
  "size": 579676,
  "content_type": "image/jpeg",
  "created_at": "2026-09-12T10:56:08Z"
}
